module.exports = __webpack_public_path__ + "images/3c7f80ddc680097b1b826c4f0abd69db.png";